import idLocale from 'element-ui/lib/locale/lang/id.js'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Interpretasi Laporan AI",
        train: "Silabus Pelatihan",
        loading: "Sedang memuat...",
        loadingError1: "Gagal memuat",
        loadingError2: "Maaf. Silakan coba lagi.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Daftar/Masuk',
        registerAndLogin: 'Masuk/Daftar',
        userLogin: 'Masuk',
        title: 'Akun telepon dan email adalah independen; mohon perhatikan tipe akun Anda.',
        mobileLogin: 'Telepon',
        emailLogin: 'Email',
        email: 'E-mail',
        loginBtn: 'Masuk',
        autoLogin: 'Ingat saya',
        retransmission: '{item}detik',
        formList: [
            {
                label: 'Masukkan nomor telepon Anda',
                placeholder: 'Kirim ',
            },
            {
                label: 'Kode Verifikasi',
                placeholder: 'Masukkan kode verifikasi',
            },
            {
                label: 'Masukkan email Anda',
            },
        ],
        btn: {
            submit: 'Buat Akun',
            title: 'Informasi yang akurat sangat penting, silakan isi dengan hati-hati.',
        },
        rule: {
            phone: {
                requiredMsg: 'Format Nomor Telepon Tidak Valid',
                patternMsg: 'Nomor telepon belum terdaftar,silakan buat akun baru.',
            },
            authCode: {
                requiredMsg: 'Kode verifikasi salah, silakan masukkan ulang.',
            },
            email: {
                requiredMsg: 'Format email tidak valid.',
                patternMsg: 'Email Tidak Terdaftar, Buat Akun Anda',
            },
        },
        codeSuccess: 'Kode verifikasi telah dikirim, silakan periksa.',
        success: 'Berhasil dikirim.',
        error: 'Pengiriman gagal.',
        loginSuccess: 'Berhasil masuk.',
        account: {
            accountTitle: 'Masuk',
            registerTitle: 'Masuk',
            resetTitle: 'Atur Kata Sandi',
            password: 'Kata Sandi',
            placeholder: 'Silakan masukkan kata sandi',
            codeLogin: 'Masuk dengan kode verifikasi',
            accountLogin: 'Masuk dengan kata sandi',
            forgotPassword: 'Lupa kata sandi?',
            registerTips:[
                'Belum punya akun?', 
                'Masuk', 
                'Akun sudah ada',
                'Daftar',
            ],
            checkRule: [
                '8-20 karakter',
                'Harus mengandung setidaknya satu huruf besar',
                'Harus mengandung setidaknya satu huruf kecil',
                'Harus mengandung setidaknya satu angka', 
                'Kata sandi tidak cocok'
            ],
            errorTips: [
                'Kata sandi salah', 
                'Gagal masuk', 
                'Akun tidak ditemukan'
            ],
            reset:[
                'Atur ulang kata sandi', 
                "Berikutnya",
                'Kata sandi baru tidak boleh sama dengan yang sebelumnya', 
                'Lewati',
                'Kata sandi berhasil diatur'
            ],
            setPasswordTips:'Kata sandi harus terdiri dari 8–20 karakter dan mencakup huruf besar, huruf kecil, dan angka.',
            confirmPassword: "Konfirmasi kata sandi",
        },
        switchButton: 'Masuk dengan Kata Sandi',
        switchButton1: 'Masuk dengan kode verifikasi',
        loginTips: 'Akun yang belum terdaftar akan otomatis terdaftar setelah berhasil masuk.',
        otherLogin: 'Metode Login Lainnya',
        newEmailLogin: 'Login dengan email',
        newPhoneLogin: 'Login dengan nomor telepon',
        bindLineTips:'Atau',
        bindEmail: 'Masuk dengan Email Tertaut',
        bindPhone: 'Masuk dengan Nomor Telepon Tertaut',
        bindAndContinue: "Hubungkan & Lanjutkan",
        bind: "Hubungkan",
        bindEmailTitle: 'Hubungkan Email',
        bindEmailTips1: "Info email {item} tidak ditemukan",
        bindEmailTips2: "Hubungkan email untuk lanjut",
        bindEmailTips3: "Email belum terhubung. Hubungkan untuk login & reset password.",
        boundTitle: 'Sudah pernah mendaftar?',
        boundCenterTitle1:'Jika Anda pengguna baru',
        boundCenterTips1:'Buat akun untuk mulai',
        boundCenterTitle2:'Jika sudah punya akun',
        boundCenterTips2:'Hubungkan untuk sinkronisasi data',
        boundCenterTips3:'Harap hubungkan akun terdaftar',
        boundCenterTips4:'Direkomendasikan',
        boundCenterTips5:'Hubungkan {item} ke akun yang ada',
        boundCenterTips6:'Data & laporan akan otomatis sinkron',
        boundButton1: 'Buat akun dengan {item}',
        boundButton2: 'Hubungkan akun yang ada',
        phoneCode:"Masuk dengan kode SMS",
        phonePassword:"Masuk dengan nomor ponsel dan kata sandi",
        emailCode:"Masuk dengan kode email",
        emailPassword:"Masuk dengan email dan kata sandi",
        accountDoesNotExist:"Akun ini belum terdaftar. Silakan daftar menggunakan kode verifikasi email atau melalui  {item}.",
        toRegister:"Daftar",
        bindNow: "Hubungkan Sekarang",
        bindError:[
            'Gagal Menautkan',
            'Berhasil Melepas Tautan',
            'Gagal Melepas Tautan',
            'Otorisasi Gagal',
            'Otorisasi Gagal, Tidak Dapat Mengambil Informasi Akun',
            'Berhasil Ditautkan',
            'Akun tidak ada. Silakan tautkan akun yang sudah terdaftar.',
            'Gagal menautkan. Akun ini sudah ditautkan ke akun {item} [{nickname}].',
            'Telah diotorisasi dan terdaftar sebagai akun, pembatalan tautan tidak didukung',
            'Akun tidak ada, silakan gunakan kode verifikasi untuk masuk dan mendaftar',
        ],
        accountSecurity: {
            faceBook:'Akun Facebook',
            google: 'Akun Google',
            isBind: 'Belum Ditautkan',
            dialogTitle: 'Konfirmasi Pelepasan Tautan?',
            dialogCenter: 'Setelah melepas tautan {item}, Anda tidak akan lagi dapat menggunakannya untuk masuk ke akun ini.',
            bindFailure:'Gagal Menautkan',
            bindFailureTips: 'Akun {item} Anda sudah ditautkan ke akun di bawah ini. Jika Anda ingin mengganti tautan ke akun saat ini, silakan masuk ke akun di bawah untuk melepas tautannya terlebih dahulu.',
            returnButton:'Konfirmasi dan Kembali'
        },
        bindEmailError: [
            "Email sudah terdaftar."
        ],
    },
    // 注册页面
    register: {
        mobileRegister: 'Telepon',
        emailRegister: 'Email',
        enroll: 'Nomor Ponsel Sudah Terdaftar',
        enrollEmail: 'Email sudah terdaftar',
        search: 'Cari',
        title: 'Akun yang diatur dengan email dan nomor telepon adalah  independen satu sama lain, silahkan',
        needRead: {
            agree: 'Saya setuju',
            privacy: '(Kebijakan Privasi)',
        },
        register: 'Daftar',
        check: 'Periksa "Privasi Pengguna"',
        newUser: 'Masuk',
        form: {
            labelList: ['Nama', '* Jenis kelamin', '* Tinggi badan', '* Usia'],
        },
        placeholder: ['Silakan masukkan nama Anda', 'Silakan masukkan tinggi Anda', 'Silakan masukkan usia Anda'],
        unit: ['Metrik', 'Imperial', ''],
        sexOptions: {
            male: 'Pria',
            female: 'Wanita',
        },
        btn: 'Kirim',
        rules: {
            metricheight: [`Rentang tinggi adalah 2'3" -  6'7", silakan masukkan lagi.`],
            heightMsg: ['Rentang tinggi adalah 70 - 200cm, silakan masukkan  lagi.'],
            ageMsg: ['Rentang usia adalah 10 - 99, silakan masukkan lagi.'],
            agePointMsg: ['Diisi bukan bilangan bulat: usia hanya bisa bilangan  bulat, silakan isi usia yang benar'],
        },
        success: 'Pendaftaran berhasil',
        userMessage: 'Masukkan Nama Pengguna',
        verify: 'Masukkan Kode Verifikasi 4 Digit',
        errorMsg: 'Format tinggi tidak mendukung desimal, silakan masukkan lagi.',
        abnormalMsg: 'Anomali pendaftaran',
    },
    // 模型合成
    model: {
        loading: 'Memuat...Silakan tunggu sebentar',
        modelLoading: 'Memuat Model 3D...',
        tabPane: [
            {
                title: 'Teknologi Deep Real Sense',
                msg: 'Mengumpulkan detail lokal tubuh secara akurat melalui  pemindaian 3D, memastikan akurasi pengukuran lingkar tingkat milimeter, dan  dengan jelas menampilkan perubahan bentuk tubuh setelah olahraga.',
            },
            {
                title: 'Algoritma Komposisi Tubuh BDA',
                msg: 'Visbody menggunakan sistem pengukuran komposisi tubuh  paling canggih - algoritma BDA untuk menentukan komposisi tubuh. Metode  perhitungan ini berdasarkan volume tubuh akan lebih akurat menilai risiko  kesehatan yang dibawa oleh obesitas.',
            },
            {
                title: 'Faktor yang menyebabkan kesalahan',
                msg: 'Pakaian longgar atau beberapa dekorasi pada/di dalam  tubuh akan menyebabkan kesalahan, silakan kenakan pakaian ketat atau kurangi  jumlah pakaian di tubuh Anda jika Anda ingin mendapatkan data yang paling  akurat.',
            },
            {
                title: 'Dapatkan laporan Anda',
                msg: 'Dianjurkan untuk menandai URL halaman web untuk  memudahkan melihat laporan di masa mendatang. Anda juga dapat mengirim  laporan ini ke kotak surat Anda untuk menyimpannya nanti.',
            },
        ],
        collect: ['Harap tandai halaman ini untuk memudahkan akses laporan di masa mendatang.', ''],
        know: 'Saya Mengerti',
        reminder: [
            'Tips Hangat',
            'Model avatar 3D Anda telah dibuat, geser ke kiri dan  kanan untuk memutar model.',
            'Laporan Anda telah dibuat dan dapat dilihat dengan  mengklik tombol "Lihat Laporan".',
            'Penilaian tubuh Anda tidak berhasil, silakan tinjau  laporan komposisi tubuh.',
            'Pengukuran komposisi tubuh tidak berhasil, silakan coba lagi pada perangkat.',
            'Pengukuran Anda tidak berhasil, silakan pergi ke  perangkat dan uji lagi~',
            'Pengukuran komposisi tubuh tidak berhasil, silakan  pergi ke perangkat dan uji lagi~',
            'Penilaian postur tidak berhasil, silakan pergi ke  perangkat dan uji lagi.~',
        ],
        btn: {
            viewReport: 'Lihat Laporan',
            bodyReport: 'Lihat Laporan Komposisi Tubuh',
            postureReport: 'Lihat Laporan Postur Tubuh',
            lastReport: 'Lihat Laporan Terakhir',
            loading: 'Memuat...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Unduh Laporan',
            send: 'Kirim Laporan',
            report: 'Laporan',
        },
        reportSuccess: 'Berhasil!',
        tabPane: {
            labelList: ['Waktu Pengukuran', 'Item', 'Komposisi Tubuh', 'Penilaian Postur', 'Fungsi Bahu'],
        },
        sendEmail: 'Email:',
        requiredMsg: 'Masukkan alamat email Anda',
        patternMsg: 'Silakan masukkan alamat email yang valid',
        send: 'Kirim',
        download: 'Unduh Laporan',
        sendReport: 'Kirim Laporan',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Perubahan jenis kelamin berhasil',
            height: 'Perubahan tinggi berhasil',
            age: 'Perubahan usia berhasil',
        },
        logOut: 'Keluar',
        personal: 'Pusat Pribadi',
        cut: 'Ubah Unit/Bahasa',
        changeSort: 'Peralihan Laporan Produk',
        setPassword: 'Atur/Ubah Kata Sandi',
        accountSecurity: 'Akun dan Keamanan',
        describe: '* Setelah mengganti model produk, semua laporan  pengukuran di bawah model ini akan ditampilkan.',
        describeBtn:
            'Setelah mengganti model produk, Anda akan dialihkan ke  laporan pengukuran terbaru di bawah model ini.',
        descReport: 'Peralihan Laporan Produk Berhasil',
        unit: ['Metrik (kg, cm)', 'Imperial (ft, in, lb)'],
        read: {
            reading: 'Baca',
            privacy: '(Kebijakan Privasi)',
        },
        setting: 'Pengaturan',
        form: {
            labelList: ['Telepon', 'Unit', 'Bahasa', 'Nama', 'Jenis Kelamin', 'Tinggi Badan', 'Usia'],
        },
        placeholder: ['Ubah Nama Pengguna Anda', 'Jenis Kelamin Baru', 'Tinggi Diperbarui', 'Usia Diperbarui'],
        btn: {
            cancelBtn: 'Batal',
            accomplishBtn: 'Selesai',
            confirmBtn: 'Konfirmasi',
        },
        dialog: [
            'Jenis kelamin adalah salah satu dasar penting untuk  pengukuran komposisi tubuh. Data yang diukur setelah modifikasi akan berbeda  dari data sebelumnya. Harap konfirmasi jika Anda ingin mengubahnya?',
            'Tinggi adalah salah satu dasar penting untuk pengukuran  komposisi tubuh. Data yang diukur setelah modifikasi akan berbeda dari data  sebelumnya. Harap konfirmasi jika Anda ingin mengubahnya?',
            'Usia adalah salah satu dasar penting untuk pengukuran  komposisi tubuh. Data yang diukur setelah modifikasi akan berbeda dari data  sebelumnya. Harap konfirmasi jika Anda ingin mengubahnya?',
        ],
        rules: {
            metricheight: [`Harap isi rentang tinggi yang benar (2'  3" hingga 6'7")`],
            heightMsg: ['Harap isi tinggi dalam 70cm - 200cm'],
            ageMsg: [
                'Harap isi usia dalam 10 - 99 tahun.',
                'Diisi bukan bilangan bulat, usia hanya bisa bilangan  bulat, silakan isi usia yang benar',
            ],
        },
        heightMsg: 'Silakan Pilih Ulang Tinggi',
        ageMsg: 'Silakan Pilih Ulang Usia',
        ModelBinding: 'Sepertinya seseorang sudah memindai kode tersebut,  silakan ukur lagi!',
        ReportEmpty: {
            title: 'Anda belum memiliki laporan apa pun',
            desc: 'Datang ke pemindai tubuh 3D Visbody dan tes lagi!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Sepertinya seseorang sudah memindai kode tersebut,  silakan ukur lagi!',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Anda belum memiliki laporan apa pun',
        desc: 'Datang ke pemindai tubuh 3D Visbody dan tes lagi!',
        descS30: 'Datang ke pemindai tubuh 3D Visbody dan tes lagi!',
        descM30: 'Datang ke pemindai tubuh 3D Visbody dan tes lagi!',
    },
    // 用户信息
    userInfo: {
        height: 'Tinggi:',
        age: 'Usia:',
        unit: 'tahun',
        weight: 'Berat',
    },
    // 体成分
    mass: {
        title: 'Ikhtisar Penilaian Komposisi Tubuh',
        titles: 'Komposisi Tubuh',
        springFrame: '',
        massFrame: 'Tidak ada data pengukuran untuk hari ini',
        contrast: 'Pilih laporan untuk dibandingkan',
        contrastReport: 'Pilih laporan untuk dibandingkan',
        noRecord: 'Tidak ada catatan',
        score: 'Skor',
        status: 'Status komposisi tubuh Anda saat ini ',
        WT: 'berat',
        PBF: 'persentase lemak',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Nilai pengukuran',
            standardRange: 'Rentang standar',
            comparedWithLastLime: 'Perbandingan',
            comparedNet: 'Dibandingkan Dengan Skor Terakhir',
            current: '本次测量分数',
            WT: 'Berat',
            FFM: 'Berat Tanpa Lemak ',
            BFM: 'Lemak ',
            LM: 'Otot',
            TBW: 'Total Air',
            SM: 'Otot Rangka',
            PROTEIN: 'Protein',
            TM: 'Mineral',
            BMR: 'Metabolisme',
            WHR: 'Rasio Pinggang-Panggul',
            BMI: 'BMI',
            PBF: 'Persentase Lemak',
            VFG: 'Lemak Viseral',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },

        // 定义解读
        explain: [
            {
                title: 'Berat',
                msg: 'Berat adalah jumlah air tubuh, protein, garam  anorganik, dan lemak tubuh.',
            },
            {
                title: 'Berat Tanpa Lemak',
                msg: 'Massa Tubuh Tanpa Lemak adalah berat badan total tanpa  lemak.',
            },
            {
                title: 'Lemak',
                msg: 'Massa lemak tubuh adalah jumlah lemak subkutan, lemak  visceral dan lemak otot.',
            },
            {
                title: 'Otot',
                msg: 'Massa otot adalah bagian dari jaringan ramping tubuh,  yang mencakup otot rangka, otot polos, dan otot jantung.',
            },
            {
                title: 'Total Air',
                msg: 'Sebagian besar tubuh manusia adalah air dengan jumlah  50%-70% dari berat badan. Dan air tubuh terutama ada di sel-sel manusia dan  cairan tubuh, sebagian besar ada di sel otot.',
            },
            {
                title: 'Otot Rangka',
                msg: 'Massa otot rangka, juga dikenal sebagai otot bergaris,  adalah jenis otot yang melekat pada tulang. Data ini mengandung jumlah Otot  Rangka.',
            },
            {
                title: 'Protein',
                msg: 'Protein adalah zat padat dengan amonia, yang ada di  semua sel tubuh manusia. Ini adalah komponen utama massa otot.',
            },
            {
                title: 'Mineral',
                msg: 'Tubuh manusia terdiri dari materi organik, materi anorganik  dan air. Materi anorganik di sini adalah garam anorganik yang jumlahnya 5%  dari berat badan.',
            },
            {
                title: 'Metabolisme',
                msg: 'Laju Metabolisme Basal adalah total energi yang  dikonsumsi dalam sehari saat tubuh sedang istirahat, tidak dipengaruhi oleh  olahraga, benda fisik, kegelisahan, perubahan suhu eksternal, dll.',
            },
            {
                title: 'Rasio Pinggang-Panggul',
                msg: 'Rasio lingkar pinggang ke pinggul, ini adalah indikator  penting untuk menentukan obesitas sentral.',
            },
            {
                title: 'BMI',
                msg: 'BMI terutama digunakan untuk menilai penampilan  obesitas, dan ini adalah standar umum untuk mengukur kegemukan tubuh.',
            },
            {
                title: 'Persentase Lemak',
                msg: 'Persentase lemak tubuh adalah rasio lemak tubuh  terhadap berat badan.',
            },
            {
                title: 'Lemak Viseral',
                msg: 'Lemak visceral adalah indikator penting untuk  mengevaluasi obesitas tersembunyi.',
            },
            {
                title: 'Cairan Intraseluler',
                msg: 'Cairan Intraseluler: Ini adalah cairan tubuh yang terkandung  dalam sel-sel tubuh dan merupakan komponen dasar protoplasma.',
            },
            {
                title: 'Cairan Ekstraseluler',
                msg: 'Cairan Ekstraseluler: Biasanya merujuk pada cairan tubuh  ekstraselular, termasuk plasma dan cairan interstisial antara pembuluh darah  dan sel-sel jaringan.',
            },
            {
                title: 'Usia Metabolik',
                msg: 'Usia metabolik merujuk pada kinerja tubuh dan fungsi kesehatan yang terkait dengan metabolisme.',
            },
            {
                title: 'Rasio ECW/TBW',
                msg: 'Rasio ECW/TBW adalah proporsi air ekstraseluler (ECW) dalam total air tubuh (TBW). Ini merupakan indikator penting untuk mengevaluasi keseimbangan cairan tubuh.',
            },
        ],
        // 节段
        segment: {
            fat: 'Lemak segmen',
            muscle: 'Otot segmen',
            right: 'Kanan',
            left: 'Kiri',
            standard: 'Normal',
            lowStandard: 'Di Bawah',
            superStandard: 'Di Atas',
            peel: '(Berat kosong)',
        },
    },
    // 体态
    shape: {
        title: 'Ikhtisar Penilaian Tubuh',
        titles: 'Postur',
        status: 'Kondisi fisik Anda saat ini',
        suggest: 'Saran',
        possibility: ', ada kemungkinan ',
        models: {
            front: 'Depan',
            left: 'Sisi Kiri',
            right: 'Sisi Kanan',
            top: 'Belakang',
            low: 'Di Bawah',
            high: 'Di Atas',
            normal: 'Normal',
        },
        item: {
            deviate: 'Nilai pengukuran',
            result: 'Penjelasan',
            normal: 'Normal',
			keAbnormal: 'Kemungkinan abnormal',
            abnormal: 'Tidak Normal',
            head: 'Kepala maju',
            headSlant: 'Kepala miring',
            roundShoulderLeft: 'Bahu bulat kiri',
            roundShoulderRight: 'Bahu bulat kanan',
            highLowShoudler: 'Bahu tidak rata',
            pelvis: 'Pergeseran panggul ke depan / ke belakang',
            leftKneeCheck: 'Evaluasi lutut kiri',
            rightKneeCheck: 'Evaluasi lutut kanan',
            leg: 'Bentuk kaki',
            leftLeg: 'Kaki kiri:',
            rightLeg: 'Kaki kanan:',
        },
        // 定义解读
        explain: [
            {
                title: 'Kepala maju',
                msg: 'Sudut antara titik telinga di sisi kiri dan garis yang  menghubungkan tengah leher dan garis median di sisi',
            },
            {
                title: 'Kepala miring',
                msg: 'Sudut antara titik tengah kepala depan dan tengah leher  dan garis tengah depan',
            },
            {
                title: 'Bahu bulat kiri',
                msg: 'Sudut antara garis yang menghubungkan titik tertinggi  di sisi kiri punggung dan garis tangen bahu',
            },
            {
                title: 'Bahu bulat kanan',
                msg: 'Sudut antara garis yang menghubungkan titik tertinggi  di sisi kanan punggung dan tangen ke bahu',
            },
            {
                title: 'Bahu tidak rata',
                msg: 'Jarak vertikal antara titik bahu kiri dan kanan di  belakang',
            },
            {
                title: 'Pergeseran panggul ke depan / ke belakang',
                msg: 'Sudut termasuk garis yang menghubungkan titik tengah  leher, titik tulang pinggul, dan titik pergelangan kaki di sisi kiri',
            },
            {
                title: 'Evaluasi lutut kiri',
                msg: 'Sudut termasuk garis tiga titik yang menghubungkan  titik tulang pinggul, sendi lutut, dan titik pergelangan kaki di sisi kiri',
            },
            {
                title: 'Evaluasi lutut kanan',
                msg: 'Sudut termasuk garis tiga titik yang menghubungkan  titik tulang pinggul, sendi lutut, dan titik pergelangan kaki di sisi kanan',
            },
            {
                title: 'Bentuk kaki',
                msg: 'Sudut termasuk garis yang menghubungkan titik tulang  pinggul, sendi lutut, dan titik pergelangan kaki di bagian depan kaki kiri  dan kanan',
            },
            {
                title: 'Kemiringan panggul ke depan/belakang',
                msg: 'Sudut antara garis vertikal dan bidang yang dibentuk oleh Spina Iliaca Anterior Superior kiri dan kanan serta Simfisis Pubis.'
            },
            {
                title: 'Diskrepansi panjang tungkai',
                msg: 'Perbedaan tinggi antara titik terendah lipatan gluteal kiri dan kanan dari lantai.'
            }
        ],
        exception: [
            {
                title: 'Miring ke Sisi Kiri',
                abnormal: '',
            },
            {
                title: 'Miring ke Sisi Kanan',
                abnormal: '',
            },
            {
                title: 'Kiri Tinggi',
                abnormal: '',
            },
            {
                title: 'Kanan Tinggi',
                abnormal: '',
            },
            {
                title: 'Kemiringan Panggul Posterior',
                abnormal: '',
            },
            {
                title: 'Kemiringan Panggul Anterior',
                abnormal: '',
            },
            {
                title: 'Hyperextension Lutut Kiri',
                abnormal: '',
            },
            {
                title: 'Lutut Kiri Membengkok ke Depan',
                abnormal: '',
            },
            {
                title: 'Hyperextension Lutut Kanan',
                abnormal: '',
            },
            {
                title: 'Lutut Kanan Membengkok ke Depan',
                abnormal: '',
            },
            {
                title: 'Kaki Bentuk-K',
                abnormal: '',
            },
            {
                title: 'Kaki Bentuk-D',
                abnormal: '',
            },
            {
                title: 'Kaki Bentuk-X',
                abnormal: '',
            },
            {
                title: 'Kaki Bentuk-O',
                abnormal: '',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Jarak vertikal antara telinga dan garis gravitasi tubuh',
            },
            {
                msg: 'Sudut antara garis yang menghubungkan kedua telinga dan bidang horizontal',
            },
            {
                msg: 'Jarak vertikal antara prosesus akromion kiri dan garis gravitasi',
            },
            {
                msg: 'Jarak vertikal antara prosesus akromion kanan dan garis gravitasi',
            },
            {
                msg: 'Perbedaan garis penghubung pangkal leher dan prosesus akromion pada kedua sisi',
            },
            {
                msg: 'Jarak vertikal antara sendi pinggul dan garis gravitasi tubuh',
            },
            {
                msg: 'Sudut yang dibentuk oleh sendi pergelangan kaki, titik 1 cm di bawah sendi lutut kiri, dan sendi pinggul pada bidang sagital',
            },
            {
                msg: 'Sudut yang dibentuk oleh sendi pergelangan kaki, titik 1 cm di bawah sendi lutut kanan, dan sendi pinggul pada bidang sagital',
            },
            {
                msg: 'Sudut antara sendi pinggul bilateral, sendi lutut, dan sendi pergelangan kaki pada bidang koronal',
            },
        ],
        item: {
            pelvis: 'Kemiringan pelvis anterior',
        },
    },
    // 围度信息
    girth: {
        title: 'Lingkaran',
        present: '(Saat Ini)',
        noHistory: 'Tidak ada data',
        tpl: [
            {
                title: 'Lingkar leher',
                key: 'neckGirth',
            },
            {
                title: 'Lingkar lengan atas kiri',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Lingkar lengan atas kanan',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Lingkar dada',
                key: 'bustGirth',
            },
            {
                title: 'Lingkar pinggang tinggi',
                key: 'waistGirth',
            },
            {
                title: 'Lingkar pinggang tengah',
                key: 'midWaistGirth',
            },
            {
                title: 'Lingkar pinggul',
                key: 'hipGirth',
            },
            {
                title: 'Lingkar paha kiri',
                key: 'leftThighGirth',
            },
            {
                title: 'Lingkar bagian tengah paha kiri',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Lingkar paha kiri terkecil',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Lingkar paha kanan',
                key: 'rightThighGirth',
            },
            {
                title: 'Lingkar bagian tengah paha kanan',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Lingkar paha kanan terkecil',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Lingkar betis kiri',
                key: 'leftCalfGirth',
            },
            {
                title: 'Lingkar betis kanan',
                key: 'rightCalfGirth',
            },
            {
                title: 'Pinggang Rendah',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Fungsi Bahu',
        model: {
            val: 'Nilai pengukuran',
            scope: 'Lokasi Aktivitas Maksimum',
            diff: 'Perbandingan',
        },
        normal: 'Tidak terdeteksi kelainan yang patut diperhatikan.',
        normalAll: 'Tidak ada kelainan signifikan dalam fungsi bahu yang terdeteksi.',
        conclusion: 'Kesimpulan',
        analyse: 'Analisis: ',
        suggest: 'Saran: ',
        cause: 'Silakan minta saran dari ahli untuk detailnya.',
    },
    reportTips: {
        title: "Apakah Anda yakin ingin menghapus laporan ini? Setelah dihapus, laporan tidak dapat dipulihkan.",
        confirm: "Hapus",
        success: "Laporan telah dihapus",
        partial: "Laporan telah dihapus, sebagian data gagal disinkronkan. Silakan hubungi administrator.",
        failed: "Penghapusan gagal, silakan coba lagi nanti",
        btnMsg: 'OK',
        alaryTips: 'Laporan ini telah dihapus oleh administrator. Akan  melompat ke laporan berikutnya!',
    },
    saveQr: {
        title: 'Laporan Pemindai Tubuh 3D Visbody',
        btnMsg: 'Tekan lama gambar untuk menyimpannya ke telepon Anda.',
        tips: 'Jika Anda merasa tidak dapat menyimpan, silakan pergi  ke [Pengaturan] dan buka izin yang sesuai.',
    },
    vanCalendar: {
        end: 'End',
        start: 'Start',
        title: 'Calendar',
        startEnd: 'Start/End',
        weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthTitle: function monthTitle(year, month) {
            return year + '/' + month
        },
        rangePrompt: function rangePrompt(maxRange) {
            return 'Choose no more than ' + maxRange + ' days'
        },
    },
    share: {
        title: 'Silakan copy tautan di bawah ini dan bagikan.',
        btnMsg: 'Salin',
    },
    "waist": {
    "title": "Lingkar abdomen-pinggang",
    "hou": "Belakang",
    "qian": "Depan"
  },
  "yao_wei_1": "Daerah pinggang",
  "yao_bu_fen_shu": "Skor pinggang",
  "waist_fen": "Skor",
  "yao_wei": "Lingkar pinggang",
  "yao_wei_jian_ti_ji": "Volume antara lingkar pinggang",
  "yao_tun_bi": "Rasio Pinggang-Panggul",
  "lun_kuo_fen_xi": "Analisis kontur",
  "bei_bu": "Punggung",
  "tunbu": "Pantat",
  "bei_bu_ti_ji": "Volume punggung",
  "zheng_chang_fan_wei": "Rentang normal:",
  "shang_ci": "Sebelum ",
  "ben_ci": "Kini ",
  "gupen": {
    "zheng_chang": "Normal",
    "qian_qin_yan_chang": "Anteversio abnormal",
    "qian_qin_yi": "Risiko anteversio",
    "hou_qin_yi": "Risiko retroversio",
    "hou_qin_yan_chang": "Retroversio abnormal",
    "zuo_chang_yan_chang": "Diskrepansi abnormal (kiri lebih panjang)",
    "zuo_chang_yi": "Risiko diskrepansi (kiri lebih panjang)",
    "you_chang_yi": "Risiko diskrepansi (kanan lebih panjang)",
    "you_chang_yan_chang": "Diskrepansi abnormal (kanan lebih panjang)"
  },
  "gao_yao_xian": "Lingkar pinggang tinggi",
  "gao_yao_zhong_xian": "Garis Tengah Pinggang Tinggi",
  "gao_yao_xia_xian": "Garis Bawah Pinggang Tinggi",
  "xiao_yao_shang_xian": "Garis Atas Pinggang Rendah",
  "xiao_yao_zhong_xian": "Garis Tengah Pinggang Rendah",
  "xiao_yao_xian": "Pinggang rendah",
  "qv_jian1": "Bagian Atas Pinggang Tinggi",
  "qv_jian2": "Bagian Bawah Pinggang Tinggi",
  "qv_jian_zhong": "Bagian Pinggang Tengah",
  "qv_jian3": "Bagian Atas Pinggang Rendah",
  "qv_jian4": "Bagian Bawah Pinggang Rendah",
  "celiang.failed": "Pengukuran gagal, harap kenakan pakaian ketat dan jaga agar tidak bergerak selama pengukuran",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Kepala menunduk/miring dengan sedikit deviasi servikal. Perhatikan postur duduk.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Kepala menunduk/miring dengan deviasi servikal. Disarankan kontrol postur dan latihan.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Kepala sangat menunduk/miring dan deviasi servikal jelas. Disarankan evaluasi profesional.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Sedikit deviasi torakal. Disarankan peningkatan kontrol postur.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Deviasi torakal memengaruhi stabilitas. Disarankan latihan spesifik.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Deviasi torakal jelas dan asimetri. Disarankan koreksi profesional.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Sedikit deviasi lumbal, postur seimbang. Disarankan stabilisasi inti.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Deviasi lumbal memengaruhi stabilitas. Disarankan latihan korektif.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Deviasi lumbal jelas. Disarankan rencana perbaikan profesional.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hipertonia: levator skapula, SCM, dan trapezius atas. Kelemahan: fleksor leher dalam. Disarankan stabilisasi dan relaksasi.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonia: SCM kiri dan skalenus posterior. Kelemahan: SCM kanan. Disarankan keseimbangan bilateral dan relaksasi.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonia: SCM kanan. Kelemahan: SCM kiri dan skalenus posterior. Disarankan stabilisasi simetris dan relaksasi.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonia: trapezius atas kiri. Kelemahan: trapezius tengah/bawah. Disarankan latihan (tengah/bawah) dan relaksasi.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hipertonia: rotator internal dan aduktor pinggul. Kelemahan: gluteus medius. Disarankan latihan gluteus dan peregangan.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hipertonia: gluteus medius dan piriformis. Kelemahan: aduktor, rotator internal, dan LCL. Disarankan stabilisasi kaki dan relaksasi gluteus.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hipertonia: gluteus medius dan piriformis. Kelemahan unilateral: aduktor, rotator internal, dan LCL. Disarankan latihan bilateral.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonia: hamstring kiri dan popliteus. Kelemahan: quadriceps dan soleus. Disarankan latihan quadriceps/soleus dan peregangan.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonia: quadriceps kiri. Kelemahan: gluteus maksimus dan hamstring. Disarankan latihan gluteus/rantai posterior dan peregangan.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonia: hamstring kanan dan popliteus. Kelemahan: quadriceps dan soleus. Disarankan latihan quadriceps/soleus dan peregangan.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonia: quadriceps kanan. Kelemahan: gluteus maksimus dan hamstring. Disarankan latihan gluteus/rantai posterior dan peregangan.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Sedikit deviasi tulang belakang. Perhatikan postur dan latih otot inti.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Deviasi tulang belakang sedang. Disarankan latihan dengan panduan profesional.",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonia: trapezius atas kanan. Kelemahan: trapezius tengah/bawah. Disarankan latihan (tengah/bawah) dan relaksasi.",
    ...idLocale,
    ...agrEn,
  "neckReport": {
  "title": "Fungsi leher",
  "conclusion": "Penilaian Fungsi Leher",
  "loading": "Laporan sedang dibuat. Harap tunggu.",
  "failed": "Laporan Gagal dalam sintesis",
  "analysis": "Analisis",
  "suggestion": "Saran",
  "suggestionText": "Temui profesional untuk pemeriksaan dan pengobatan penyebab spesifik."
}
}
